class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      // Listen to both 'input' and 'change' events - checkboxes fire 'change', text inputs fire 'input'
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));
      facetForm.setAttribute('data-input-listener-attached', 'true');
    }
    if (!window.__pheFacetsToggleDebug) {
      window.__pheFacetsToggleDebug = true;
      document.addEventListener('toggle', function(e) {
        const target = e.target;
        if (target && target.classList && target.classList.contains('mobile-facets__details')) {
          if (window.innerWidth >= 990 && !target.hasAttribute('open')) {
            target.setAttribute('open', 'open');
          }
        }
      }, true);
    }

    if (!window.__pheFacetsSummaryGuard) {
      window.__pheFacetsSummaryGuard = true;
      document.addEventListener('click', function(e) {
        if (window.innerWidth < 990) return;
        const summary = e.target.closest?.('.mobile-facets__summary');
        if (!summary) return;
        const details = summary.closest('details');
        if (details && details.classList.contains('mobile-facets__details')) {
          e.preventDefault();
          e.stopPropagation();
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', 'open');
          }
        }
      }, true);
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        try {
          FacetFiltersForm.renderFilters(html, event);
        } catch (error) {}
        try {
          FacetFiltersForm.renderProductGridContainer(html);
        } catch (error) {}
        try {
          FacetFiltersForm.renderProductCount(html);
        } catch (error) {}
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch((error) => {
        // Error handling
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newProductGrid = parsedHTML.getElementById('ProductGridContainer');
    if (newProductGrid && document.getElementById('ProductGridContainer')) {
      document.getElementById('ProductGridContainer').innerHTML = newProductGrid.innerHTML;
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Re-initialize Swiper galleries after product grid update
    setTimeout(() => {
      // Find all Swiper initialization scripts in the updated HTML
      const swiperScripts = document.querySelectorAll('#ProductGridContainer script[data-card-id]');
      swiperScripts.forEach(script => {
        try {
          // Execute the script content
          const scriptContent = script.textContent || script.innerHTML;
          if (scriptContent) {
            // Create a new script element and execute it
            const newScript = document.createElement('script');
            newScript.textContent = scriptContent;
            document.body.appendChild(newScript);
            document.body.removeChild(newScript);
          }
        } catch (e) {}
      });
    }, 100);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
        
        // Re-attach event listeners to the form after innerHTML update
        const facetForm = currentElement.closest('facet-filters-form');
        if (facetForm) {
          const form = facetForm.querySelector('form');
          if (form && !form.hasAttribute('data-input-listener-attached')) {
            // Listen to both 'input' and 'change' events - checkboxes fire 'change', text inputs fire 'input'
            form.addEventListener('input', facetForm.debouncedOnSubmit.bind(facetForm));
            form.addEventListener('change', facetForm.debouncedOnSubmit.bind(facetForm));
            form.setAttribute('data-input-listener-attached', 'true');
          }
        }
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    if (window.innerWidth >= 990) {
      document.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__details').forEach((details) => {
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', 'open');
        }
      });
    }
    // Close mobile facets drawer after filter update (if it was open)
    const menuDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    const wasDrawerOpen = menuDrawer?.mainDetailsToggle?.hasAttribute('open');
    if (wasDrawerOpen && menuDrawer && event) {
      // Check if this was triggered by a filter selection (not just a page load)
      const isFilterEvent = event.target && (
        event.target.closest('.mobile-facets__checkbox') ||
        event.target.closest('input[type="checkbox"]') ||
        event.target.closest('.js-filter')
      );
      if (isFilterEvent) {
        // Intentionally keep drawer open for filter events.
      }
    }
    
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const currentElement = document.querySelector(selector);
      if (currentElement) {
        // Remove data-sort-initialized from any sort dropdowns before updating HTML
        currentElement.querySelectorAll('.mobile-sort-dropdown[data-sort-initialized]').forEach(dropdown => {
          dropdown.removeAttribute('data-sort-initialized');
        });
        currentElement.innerHTML = html.querySelector(selector).innerHTML;
      }
    });

    const menuDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
    
    // Re-initialize sort dropdowns immediately after HTML update
    if (typeof window.initMobileSortDropdowns === 'function') {
      try {
        window.initMobileSortDropdowns();
      } catch (error) {
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const eventFormId = event.target?.closest('form')?.id;
    
    // Check both srcElement and target for mobile checkbox
    const eventSrcElement = event.srcElement || event.target;
    const isMobileCheckbox = eventSrcElement?.className == 'mobile-facets__checkbox' || 
                            event.target?.className == 'mobile-facets__checkbox' ||
                            event.target?.classList?.contains('mobile-facets__checkbox');
    if (isMobileCheckbox) {
      // Skip auto-apply for mobile facets; apply is handled by the Apply button.
      return;
    } else {
      const forms = [];
      const isMobile = eventFormId === 'FacetFiltersFormMobile' || eventFormId === 'FacetSortMobileOutside';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else {
          // Mobile: include both the drawer form and the outside sort form
          if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortMobileOutside') {
            forms.push(this.createSearchParams(form));
          }
        }
      });
      
      const combinedParams = forms.join('&');
      this.onSubmitForm(combinedParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Apply button for drawer filters: submit selected filters, then close drawer
if (!window.__pheFacetApplyHandler) {
  window.__pheFacetApplyHandler = true;
  document.addEventListener('click', function (e) {
    const applyBtn = e.target.closest?.('.mobile-facets__apply, .mobile-facets__footer .button.button--primary');
    if (!applyBtn || applyBtn.closest('facet-remove')) return;
    e.preventDefault();
    e.stopPropagation();

    const form = applyBtn.closest('form') || document.getElementById('FacetFiltersFormMobile');
    const forms = [];
    if (form) forms.push(new URLSearchParams(new FormData(form)).toString());
    const sortOutside = document.getElementById('FacetSortMobileOutside');
    if (sortOutside) forms.push(new URLSearchParams(new FormData(sortOutside)).toString());
    const params = forms.filter(Boolean).join('&');

    FacetFiltersForm.renderPage(params, e);

    const wrapper = applyBtn.closest('.mobile-facets__wrapper');
    const details = wrapper?.querySelector('details.mobile-facets__disclosure');
    if (details?.hasAttribute('open')) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      wrapper.classList.remove('menu-opening');
    }
  }, true);
}

// Handle mobile sort dropdown (menu style)
(function() {
  let initialized = false;
  
  // Make initMobileSortDropdowns globally accessible
  window.initMobileSortDropdowns = function() {
    const uninitializedDropdowns = document.querySelectorAll('.mobile-sort-dropdown:not([data-sort-initialized])');
    
    uninitializedDropdowns.forEach(dropdown => {
      dropdown.setAttribute('data-sort-initialized', 'true');
      const summary = dropdown.querySelector('summary.mobile-sort-dropdown__trigger');
      const options = dropdown.querySelectorAll('.mobile-sort-dropdown__option');
      const hiddenInput = dropdown.closest('form')?.querySelector('input[name="sort_by"]');
      
      // Add click handler to summary to toggle dropdown
      if (summary) {
        summary.addEventListener('click', function(e) {
          // Prevent default to stop browser from toggling details element
          e.preventDefault();
          // Stop propagation to prevent click-outside handler from firing immediately
          e.stopPropagation();
          
          const isOpen = dropdown.hasAttribute('open');
          if (isOpen) {
            dropdown.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            dropdown.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
          }
        });
      }
      
      options.forEach(option => {
        option.addEventListener('click', function(e) {
          const value = this.dataset.value;
          
          e.preventDefault();
          e.stopPropagation();
          
          // Re-query for hidden input in case it was replaced
          const currentHiddenInput = dropdown.closest('form')?.querySelector('input[name="sort_by"]');
          
          // Update hidden input
          if (currentHiddenInput) {
            currentHiddenInput.value = value;
          }
          
          // Update selected state - re-query options in case they were replaced
          const currentOptions = dropdown.querySelectorAll('.mobile-sort-dropdown__option');
          currentOptions.forEach(opt => opt.classList.remove('mobile-sort-dropdown__option--selected'));
          this.classList.add('mobile-sort-dropdown__option--selected');
          
          // Close dropdown
          dropdown.removeAttribute('open');
          
          // Submit form
          const form = dropdown.closest('form');
          
          if (form) {
            const facetForm = form.closest('facet-filters-form');
            
            if (facetForm) {
              // Trigger input event on the hidden input - this is what FacetFiltersForm listens for
              // Use currentHiddenInput (re-queried) instead of the closure variable
              if (currentHiddenInput) {
                // Create a native input event that will bubble to the form
                const inputEvent = new Event('input', { bubbles: true, cancelable: true });
                currentHiddenInput.dispatchEvent(inputEvent);
                
                // Also try change event as some forms listen for that
                const changeEvent = new Event('change', { bubbles: true, cancelable: true });
                currentHiddenInput.dispatchEvent(changeEvent);
              } else {
                // Fallback: trigger on form directly
                const formInputEvent = new Event('input', { bubbles: true, cancelable: true });
                form.dispatchEvent(formInputEvent);
              }
            }
          }
        });
      });
    });
    
    // Close dropdown when clicking outside (single listener for all dropdowns)
    if (!initialized) {
      initialized = true;
      document.addEventListener('click', function(e) {
        // Don't close if clicking on the sort dropdown itself (including summary)
        if (e.target.closest('.mobile-sort-dropdown')) {
          return;
        }
        const openDropdowns = document.querySelectorAll('.mobile-sort-dropdown[open]');
        openDropdowns.forEach(dropdown => {
          dropdown.removeAttribute('open');
        });
      });
    }
  };
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initMobileSortDropdowns);
  } else {
    window.initMobileSortDropdowns();
  }
  
  // Note: Re-initialization is now handled directly in renderAdditionalElements
  // No need for a separate renderPage wrapper
})();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
